import { render, staticRenderFns } from "./chainSupplyTree.vue?vue&type=template&id=979f3472&scoped=true"
import script from "./chainSupplyTree.vue?vue&type=script&lang=js"
export * from "./chainSupplyTree.vue?vue&type=script&lang=js"
import style0 from "./chainSupplyTree.vue?vue&type=style&index=0&id=979f3472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979f3472",
  null
  
)

export default component.exports